import { render } from "./ColunaGrade.vue?vue&type=template&id=f626bd72&scoped=true&ts=true"
import script from "./ColunaGrade.vue?vue&type=script&lang=ts"
export * from "./ColunaGrade.vue?vue&type=script&lang=ts"

import "./ColunaGrade.vue?vue&type=style&index=0&id=f626bd72&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f626bd72"]])

export default __exports__